import type { HelpFile } from '../../types/help'
import { CertificationPoliciesTestIds } from '../../../testids/CertificationPoliciesTestIds'

export const certificationPoliciesHelp: HelpFile = {
  docPage: '/docs/governance/certification-policies',
  texts: {
    [CertificationPoliciesTestIds.certificationPoliciesList]: 'Zertifizierungsrichtlinien definieren wiederkehrende Kampagnenvorlagen — Umfang, Zeitplan und Prüferzuweisung.',
    [CertificationPoliciesTestIds.btnCreatePolicy]: null,
    [CertificationPoliciesTestIds.colName]: null,
    [CertificationPoliciesTestIds.colPriority]: 'Richtlinien werden in aufsteigender Reihenfolge ausgewertet — niedrigere Priorität zuerst.',
    [CertificationPoliciesTestIds.colConditions]: 'Anzahl der Umfangsbedingungen, die festlegen, welche Identitäten und Zugriffsprofile diese Richtlinie erfasst.',
    [CertificationPoliciesTestIds.colFrequency]: 'Zeitabstand, in dem Kampagnen aus dieser Richtlinie automatisch erzeugt werden.',
    [CertificationPoliciesTestIds.colStatus]: null,
  },
}
